import { Col, Row, Button } from 'antd';
import React from 'react';
import AdminHeader from '../../globals/Layout/Admin/AdminHeader';
import TUser from './Tables/TUser';
import { UserState } from '../../store/user/types';
import { connect } from 'react-redux';
import { AppState } from '../../store';
import TGeiInventory from './Tables/TGeiInventory';
import styles from 'src/components/Admin/Result/Results.module.scss';
import { useHistory } from 'react-router-dom';
interface GeiInventoryProps {
    user: UserState;
}
const GeiInventory: React.FC<GeiInventoryProps> = (props: GeiInventoryProps) => {
    const history = useHistory();
    return (
        <div>
           <div>
                <br />
                <div className={styles["admin-header"]}>
                    <div ><span className={styles["header"]}> Información inventario GEI</span>
                    </div>
                </div>
                <br />
            </div>
            <TGeiInventory/>
             
        </div>

    );
};
const mapStateToProps = (state: AppState) => ({
    user: state.user
});
export default connect(mapStateToProps, {
})(GeiInventory);